export default __webpack_public_path__ + "static/media/grow.df11547a.jpeg";